import { render, staticRenderFns } from "./SafetyForm.vue?vue&type=template&id=436d0eec&scoped=true&"
import script from "./SafetyForm.vue?vue&type=script&lang=js&"
export * from "./SafetyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436d0eec",
  null
  
)

export default component.exports